import React from 'react'
import _ from 'lodash'
import {
  Col,
  FormInput,
  FormInputDate,
  FormInputSelect,
  FormInputText,
  Row
} from 'camino-react'

const TicketStatusFields = ({
  selectedTicketStatusIs,
  ticketStatuses,
  onValue,
  statusId,
  reopenOn,
  onHoldDescription,
  rootCause,
  preventiveAction,
  correctiveAction,
  disableTicketStatusSelect,
  ticketTypeId
}) => (
  <React.Fragment>
    {!disableTicketStatusSelect && (
      <Row classExtra="row--bottom-spaced">
        <Col>
          <FormInput label="Ticket Status">
            <FormInputSelect
              options={ticketStatuses}
              value={_.find(ticketStatuses, ['value', statusId])}
              onValue={value => onValue('statusId', value)}
            />
          </FormInput>
        </Col>
      </Row>
    )}

    {(selectedTicketStatusIs('On Hold') || selectedTicketStatusIs('Scheduled')) && (
      <Row classExtra="row--bottom-spaced">
        <Col>
          <FormInput label="When will this ticket re-open?">
            <FormInputDate
              enableTime={false}
              value={reopenOn}
              onValue={value => onValue('reopenOn', value)}
            />
          </FormInput>
        </Col>
        <Col>
          <FormInput label="Why is this ticket being put on hold?">
            <FormInputText
              value={onHoldDescription}
              onValue={value => onValue('onHoldDescription', value)}
            />
          </FormInput>
        </Col>
      </Row>
    )}
    {selectedTicketStatusIs('Resolved') && ticketTypeId !== 2 && (
      <>
        <Row classExtra="row--bottom-spaced">
          <Col>
            <FormInput label="What was the root cause?">
              <FormInputText
                value={rootCause}
                onValue={value => onValue('rootCause', value)}
              />
            </FormInput>
          </Col>
        </Row>
        <Row classExtra="row--bottom-spaced">
          <Col>
            <FormInput label="What is the preventive action?">
              <FormInputText
                value={preventiveAction}
                onValue={value => onValue('preventiveAction', value)}
              />
            </FormInput>
          </Col>
        </Row>
        <Row classExtra="row--bottom-spaced">
          <Col>
            <FormInput label="How did you correct the issue?">
              <FormInputText
                value={correctiveAction}
                onValue={value => onValue('correctiveAction', value)}
              />
            </FormInput>
          </Col>
        </Row>
      </>
    )}
  </React.Fragment>
)
export default TicketStatusFields
